import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { getNotfoundAttrs } from "../apis/notfound";
import { INotfoundData } from "../models/type";

const useNotfoundAttrQuery = (): UseQueryResult<INotfoundData> => {
  const fetchAttrs = () => {
    return getNotfoundAttrs();
  };

  // cacheTime: 24 * 60 mins
  // is the duration React Query stores inactive data before it is deleted from the cache
  // staleTime: 23 * 60 mins
  // is the duration data is considered fresh

  // Set staleTime: Infinity,
  // There will only be one fetch, and all other invocations will only read from the cache

  // const data = useQuery(["notfound"], fetchAttrs, {
  //   staleTime: 1000 * 60 * 60 * 23,
  //   cacheTime: 1000 * 60 * 60 * 24,
  // });

  const data = useQuery(["notfound"], fetchAttrs, {
    staleTime: Infinity,
  });

  return data;
};

export default useNotfoundAttrQuery;
